import React from "react";

const Heading = ({ data }) => {
  return (
    <div
      className={`text-black py-6 lg:py-10 ${
        data.alignment === "left" ? "text-left" : "text-center"
      }`}
    >
      <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold leading-normal">
        {data.title}
      </h2>
      {data.description && (
        <p
          className={`text-lg whitespace-pre-wrap max-w-2xl ${
            data.alignment === "left" ? "mx-0" : "mx-auto"
          }`}
        >
          {data.description}
        </p>
      )}
    </div>
  );
};

export default Heading;
